import { AsyncPipe, CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  Assignment,
  AssignmentStatus,
  AssignmentStatusStateModel,
} from "../model/model";
import {
  MarkFailAction,
  MarkPassAction,
  PlanningState,
  ResetAssignmentAction,
  UnplanCandidateAction,
} from "../store/planning.state";
import { StatusButtonComponent } from "./status-button.component";

@Component({
  selector: "app-status-button-group",
  standalone: true,
  imports: [CommonModule, AsyncPipe, StatusButtonComponent],
  styles: [``],
  template: `<ng-container
    *ngIf="assignmentStatusState$ | async as assignmentStatusState"
  >
    <app-status-button
      (click)="stateChange(assignmentStatusState.assignment, $event)"
      *ngFor="let statusButton of assignmentStatusState.buttons"
      [disabled]="statusButton.disabled"
      [active]="statusButton.disabled"
      [state]="statusButton.status"
    >
    </app-status-button>
  </ng-container>`,
})
export class StatusButtonGroupComponent {
  public assignmentStatusState$: Observable<AssignmentStatusStateModel>;

  constructor(private store: Store) {
    this.assignmentStatusState$ = this.store
      .select(PlanningState.selectedAssignment)
      .pipe(
        map((a) => ({
          assignment: a,
          buttons: a
            ? [
                {
                  status: AssignmentStatus.PassedManually,
                  flex: 1,
                  disabled:
                    this.passed(a.status) ||
                    a.status === AssignmentStatus.AwaitingUpdate,
                },
                {
                  status: AssignmentStatus.FailedManually,
                  flex: 1,
                  disabled:
                    this.failed(a.status) ||
                    a.status === AssignmentStatus.AwaitingUpdate,
                },
                {
                  status:
                    this.failed(a.status) ||
                    this.passed(a.status) ||
                    a.status === AssignmentStatus.TestStarted
                      ? AssignmentStatus.Assigned
                      : AssignmentStatus.Unassigned,
                  flex: 1,
                  disabled:
                    a.status === AssignmentStatus.AwaitingUpdate ||
                    a.candidateLeft,
                },
              ]
            : [],
        }))
      );
  }

  public stateChange(assignment: Assignment, state: AssignmentStatus) {
    const candidateId = assignment.candidateId;
    const learningObjectiveId = assignment.learningObjectiveId;
    switch (state) {
      case AssignmentStatus.Assigned:
        this.store.dispatch(
          new ResetAssignmentAction(candidateId, learningObjectiveId)
        );
        break;
      case AssignmentStatus.Unassigned:
        this.store.dispatch(
          new UnplanCandidateAction(candidateId, learningObjectiveId)
        );
        break;
      case AssignmentStatus.FailedManually:
      case AssignmentStatus.PassedManually:
        this.store.dispatch(
          state === AssignmentStatus.PassedManually
            ? new MarkPassAction(candidateId, learningObjectiveId)
            : new MarkFailAction(candidateId, learningObjectiveId)
        );
        break;
    }
  }
  private failed = (status: AssignmentStatus) =>
    status === AssignmentStatus.FailedManually ||
    status === AssignmentStatus.Failed;
  private passed = (status: AssignmentStatus) =>
    status === AssignmentStatus.PassedManually ||
    status === AssignmentStatus.Passed;
}
